import axios from "axios";
import { extApi,tmsApi } from "../api";

export const getExternalThirdPartyList = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(extApi + `v2/entities/thirdparty/client/list?page=${obj.page}&size=${obj.size}`, {
                serviceCityId: obj.serviceCityId
            }, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};
export const getExternalThirdPartyListings = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(extApi + `v2/entities/thirdparty/client/list`, {
                serviceCityId: null
            }, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};
export const getExternalThirdPartyListBySearch = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(extApi + `v2/entities/thirdparty/client/search/${obj.serviceCityId}/${obj.name}`,  config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};
export const getExternalThirdParty = (id) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(extApi + `v2/entities/thirdparty/client/details/${id}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};
export const createExternalThirdPartyClient = (body) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(extApi + `v2/entities/thirdparty/client/create`, body, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};
export const updateExternalThirdPartyClient = (body) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .put(extApi + `v2/entities/thirdparty/client/update`, body, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};
export const getPackagesListExt = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/packages/thirdpartyclient`,{
                // isPagination: obj.isPagination,
                // serviceCityId: obj.serviceCityId
                "serviceCityId": null,
                "thirdPartyClientId":obj.corporateId
            }, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};
